import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../components/rootLayout/RootLayout";
import Home from "../pages/home/Home";
import About from "../pages/about/About";
import Shop from "../pages/shop/Shop";
import Contact from "../pages/contact/Contact";
import Athletes from "../pages/athletes/Athletes";
import Profile from "../components/profile/Profile";
import NotFound from "../components/notFound/NotFound";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions/TermsConditions";
import Trainings from "../pages/training/Trainings";
import TrainingCourse from "../pages/training/TrainingCourse";
import ResetPasswordTrigger from "../pages/register/ResetPasswordTrigger";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/home", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/shop", element: <Shop /> },
      // { path: "/trainings", element: <Trainings /> },
      { path: "/onlinecourses", element: <Trainings /> },
      { path: "/athletes", element: <Athletes /> },
      { path: "/contact", element: <Contact /> },
      // { path: "/blogs", element: <Blogs /> },
      // { path: "/login", element: <Login /> },
      { path: "/profile", element: <Profile /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/terms-conditions", element: <TermsConditions /> },
      { path: "/reset-password", element: <ResetPasswordTrigger /> },
      { path: "/onlinecourses/:trainingId", element: <TrainingCourse /> },

    ],
  },
  // {
  //   path: "/auth",
  //   element: <AouthLayout />,
  //   children: [
  //     { path: "/auth/login", element: <Login /> },
  //     { path: "/auth/register", element: <Register /> },
  //   ],
  // },
  {
    path: "*",
    element: <NotFound />,
  },
]);
